import {useTheme} from '@mui/material/styles';
import type {Theme} from '@mui/material/styles';
import type {CustomTheme} from '@root/common/themeInterfaces';

type BrandTheme = Theme & {custom: CustomTheme};

export function useBrandTheme(): BrandTheme {
  return useTheme<BrandTheme>();
}
